module.exports = __webpack_public_path__ + "img/acreol.d910dc2c.png";